module.exports = __webpack_public_path__ + "media/dashboard/assets/images/inbox_icons/facebook-badge-b569304d520b91e1a1b0d7490cb50d48.svg";